"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("./colors"));
const commonStyles = react_native_1.StyleSheet.create({
    boxStyles: {
        borderColor: colors_1.default.BORDER_COLOR,
        borderWidth: 1,
        borderRadius: 8,
        backgroundColor: colors_1.default.WHITE,
        margin: 5,
        padding: 20,
        minWidth: 250,
    },
    minHeight: {
        minHeight: 275,
    },
    allScreenWeb: {
        minHeight: '90vh',
        backgroundColor: colors_1.default.BACKGROUND_COLOR,
    },
    allScreenMobile: {
        flex: 1,
        flexDirection: 'column',
        backgroundColor: colors_1.default.BACKGROUND_COLOR,
    },
    centerChilds: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
    },
    textBold: {
        fontWeight: 'bold',
    },
    textColorBlack: {
        color: colors_1.default.FONT_BLACK,
    },
    textColorRed: {
        color: colors_1.default.FONT_RED,
    },
    textColorGray: {
        color: colors_1.default.FONT_GRAY,
    },
    textColorBlue: {
        color: colors_1.default.BLUE,
    },
    textColorWhite: {
        color: colors_1.default.WHITE,
    },
    textCenter: {
        textAlign: 'center',
    },
    alignCenterStart: {
        justifyContent: 'center',
        alignItems: 'flex-start',
        alignSelf: 'center',
    },
    alignCenterEnd: {
        justifyContent: 'center',
        alignItems: 'flex-end',
        alignSelf: 'center',
    },
    justifyContentEnd: {
        justifyContent: 'flex-end',
    },
    alignCenterCenter: {
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
    },
    alignSpaceEvenly: {
        justifyContent: 'space-evenly',
    },
    alignSpaceBetween: {
        justifyContent: 'space-between',
    },
    alignLeft: {
        justifyContent: 'flex-end',
    },
    alignRight: {
        justifyContent: 'flex-start',
    },
    flexDirectionRow: {
        flexDirection: 'row',
    },
    flexDirectionColumn: {
        flexDirection: 'column',
    },
    flexOne: {
        flex: 1,
    },
    flexTwo: {
        flex: 2,
    },
    flexThree: {
        flex: 3,
    },
    flexFour: {
        flex: 4,
    },
    flexFive: {
        flex: 5,
    },
    flexWrap: {
        flexWrap: 'wrap',
    },
    marginFive: {
        margin: 5,
    },
    marginTen: {
        margin: 10,
    },
    marginBottomTen: {
        marginBottom: 10,
    },
    marginBottomTwenty: {
        marginBottom: 20,
    },
    marginTwenty: {
        margin: 20,
    },
    marginLeftFive: {
        marginLeft: 5,
    },
    marginLeftTen: {
        marginLeft: 10,
    },
    marginLeftTwenty: {
        marginLeft: 20,
    },
    marginLeftThirty: {
        marginLeft: 30,
    },
    marginRightTen: {
        marginRight: 10,
    },
    marginTopTen: {
        marginTop: 10,
    },
    marginTopForty: {
        marginTop: 40,
    },
    fontSizeText: {
        fontSize: 14,
    },
    borderWidthOne: {
        borderWidth: 1,
    },
    borderWidthTwo: {
        borderWidth: 2,
    },
    textInput: {
        borderColor: colors_1.default.BORDER_COLOR,
        borderWidth: 1,
        borderRadius: 8,
        backgroundColor: colors_1.default.WHITE,
        margin: 3,
        minWidth: 250,
    },
    selectInput: {
        borderColor: colors_1.default.BORDER_COLOR,
        borderWidth: 1,
        borderRadius: 8,
        backgroundColor: colors_1.default.WHITE,
        margin: 3,
    },
    blackBackgroundColor: {
        backgroundColor: 'black',
    },
    labelRed: {
        backgroundColor: colors_1.default.RED,
        borderRadius: 30,
    },
    greenLabel: {
        backgroundColor: colors_1.default.GREEN,
        borderRadius: 30,
    },
    yellowLabel: {
        backgroundColor: colors_1.default.YELLOW,
        borderRadius: 30,
    },
    grayLabel: {
        backgroundColor: colors_1.default.BOXES_COLOR,
        borderRadius: 30,
    },
    whiteBackground: {
        backgroundColor: colors_1.default.WHITE,
    },
    blueBackground: {
        backgroundColor: colors_1.default.BLUE,
    },
    blueBackground_2: {
        backgroundColor: colors_1.default.BLUE_2,
    },
    redBackground: {
        backgroundColor: colors_1.default.RED,
    },
    greenBackground: {
        backgroundColor: colors_1.default.GREEN,
    },
    grayBackground: {
        backgroundColor: colors_1.default.GRAY_2,
    },
    blueBorder: {
        borderColor: colors_1.default.BLUE,
    },
    grayBorder: {
        borderColor: colors_1.default.GRAY_2,
    },
    redBorder: {
        borderColor: colors_1.default.RED,
    },
    borderRadiusFour: {
        borderRadius: 4,
    },
    button: {
        display: 'flex',
        alignItems: 'center',
        paddingTop: 3,
        paddingBottom: 3,
        paddingLeft: 20,
        paddingRight: 20,
        borderRadius: 3,
        flex: 1,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 20,
        marginRight: 20,
        minWidth: 250,
        minHeight: 40,
    },
    minWidth: {
        minWidth: 100,
    },
    tableCellMaxWidth: {
        maxWidth: 100,
    },
    contentContainerStyle: {
        flexGrow: 1,
        justifyContent: 'space-between',
    },
    anchorStyle: {
        borderWidth: 1,
        borderColor: colors_1.default.GRAY_2,
        borderRadius: 3,
        alignItems: 'center',
        margin: 40,
        padding: 2,
    },
    roundedIconContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        width: 50,
        height: 50,
        backgroundColor: colors_1.default.WHITE,
        borderRadius: 50,
    },
    textTitle: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: 16,
        lineHeight: 24,
        color: colors_1.default.FONT_BLACK,
    },
    fontWeightBold: {
        fontWeight: 'bold',
    },
    textError: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: 16,
        lineHeight: 24,
        color: colors_1.default.FONT_RED,
    },
    customPhoneInput: {
        height: 50,
        marginHorizontal: 40,
        marginBottom: 5,
    },
    maxHeight: {
        maxHeight: '100%',
    },
    fullWidth: {
        width: '100%',
    },
    fullHeight: {
        height: '100%',
    },
    maxTableHeight: {
        maxHeight: 500,
    },
    minWidthLarge: {
        minWidth: 950,
    },
    alignItemsCenter: {
        alignItems: 'center',
    },
    paddingZero: {
        padding: 0,
    },
    paddingTen: {
        padding: '10px',
    },
    paddingTopTen: {
        paddingTop: '10px',
    },
    paddingBottomTen: {
        paddingBottom: '10px',
    },
    paddingFour: {
        padding: '4px',
    },
    paddingTwenty: {
        padding: 20,
    },
    paddingRightTen: {
        paddingRight: 10,
    },
    bottomBorder: {
        borderBottomWidth: 1,
    },
    // Modal
    centeredView: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 22,
    },
    modalView: {
        margin: 20,
        backgroundColor: 'white',
        borderRadius: 20,
        padding: 35,
        alignItems: 'center',
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
    },
    modalText: {
        marginBottom: 30,
        textAlign: 'center',
    },
    modelFormTop: {
        top: react_native_1.Dimensions.get('window').height * 0.2,
    },
    modalWidth: {
        width: react_native_1.Dimensions.get('window').width * 0.8,
    },
    // DataTable
    shortCellWidth: {
        minWidth: 120,
        flex: 1,
    },
    mediumCellWidth: {
        minWidth: 150,
        flex: 1.5,
    },
    longCellWidth: {
        minWidth: 300,
        flex: 3.5,
    },
    select: {
        width: '100%',
        marginTop: 10,
        height: 60,
    },
});
exports.default = commonStyles;
